import get from "lodash/get";

let previousLocation = typeof window === "object" && window.location.pathname;
/**
 * regular expressions to match the number section from the quiz quiestion URL
 * "/quiz/10" yields "10"
 * @type {RegExp}
 */
const matchRegx = /([0-9]+)(?=[^/]*$)/g;

export const defaultStyle = {
  transition: "transform 200ms ease-in-out",
};

/**
 * Return previous and current quiz location based on browser URL state
 * @return {Object} Previous and Current State
 */
const getDerivedLocations = () => {
  const location = typeof window === "object" && window.location.pathname;

  if (!location) {
    return {
      previousStep: 1,
      currentStep: 1,
    };
  }

  const previousMatch = previousLocation?.match(matchRegx);
  const currentMatch = location?.match(matchRegx);

  const current = get(currentMatch, "[0]", 1);
  const previous = get(previousMatch, "[0]", current);

  return {
    previousStep: parseInt(previous),
    currentStep: parseInt(current),
  };
};

/**
 * QuestionLayout slide transition, left/right based on direction [forward, backwards]
 * @return {Object} Animations states for react-transition-group
 */
export const getTransitionStyles = () => {
  const { previousStep, currentStep } = getDerivedLocations(previousLocation);
  const direction = currentStep > previousStep ? 1 : -1;
  return {
    entering: {
      transform: `translateX(${-100 * direction}%)`,
    },
    entered: {
      transform: "translateX(0)",
    },
    exited: {
      transform: `translateX(${100 * direction}%)`,
    },
  };
};

/**
 * ProgressBar fill transition based on quiz direction [forward, backwards]
 * @param  {Number} quizLength Total number of quesitons
 * @param  {Number} step       Current question id
 * @return {Object}            Object defining the animation that should applied
 */
export const progressBarTransition = (quizLength, step) => {
  const { previousStep, currentStep } = getDerivedLocations(previousLocation);
  const unit = 100 / quizLength;
  let state = currentStep < previousStep ? step + 1 : step - 1;
  let amount = unit * state;
  let fill = -100 + amount;

  return {
    transform: `translateX(${fill}%)`,
  };
};

export const updateLocation = () => {
  previousLocation = window.location.pathname;
};
